import * as React from 'react';
import { Redirect } from 'react-router';
import * as _ from 'underscore';
import { ServiceLocator } from '../../app/ServiceLocator';
import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { Filter } from '../../ts/helpers/Filter';
import { IDataRoleInfo } from '../../ts/models/IDataRoleInfo';
import { DataRoles } from '../../ts/resources/Dataroles';
import { Favorites } from '../../ts/resources/Favorites';

export interface RedirectToFavoritedDataRoleProviderProps {
  readonly roleId: string;
  readonly urls: SpacesSiteUrls;
}

export interface RedirectToFavoritedDataRoleProviderState {
  readonly roleExists: boolean;
  readonly hasError: boolean;
}

const InitialState: RedirectToFavoritedDataRoleProviderState = {
  roleExists: false,
  hasError: false
};

export class RedirectToFavoritedDataRoleProvider extends React.PureComponent<RedirectToFavoritedDataRoleProviderProps, RedirectToFavoritedDataRoleProviderState> {
  private unmounted: boolean = false;

  public constructor(props: RedirectToFavoritedDataRoleProviderProps) {
    super(props);
    this.state = InitialState;
  }

  public render(): JSX.Element {
    if (this.state.hasError) {
      return <RouterError errorType={'datarole-removed-favorite'} urls={this.props.urls} />;
    } else if (this.state.roleExists) {
      return <Redirect to={this.props.urls.dataRolePath(this.props.roleId)} />;
    }

    return null;
  }

  public async componentDidMount() {
    if (_.isUndefined(this.props.roleId)) {
      this.setToErrorStateAndRemoveFromFavorites();
      return;
    }

    try {
      const DataRoles = ServiceLocator.get<DataRoles>('DataRoles');
      const dataRole: IDataRoleInfo = await DataRoles.all()
        .withFilters([Filter.fieldEq('id', this.props.roleId)])
        .getFirst();

      if (dataRole) {
        this.updateState({ roleExists: true });
      } else {
        this.setToErrorStateAndRemoveFromFavorites();
      }

    } catch (e) {
      this.setToErrorStateAndRemoveFromFavorites();
    }
  }

  private setToErrorStateAndRemoveFromFavorites() {
    const Favorites = ServiceLocator.get<Favorites>('Favorites');
    Favorites.remove(this.props.roleId, 'dataRole');
    this.updateState({ hasError: true });
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  private updateState<K extends keyof RedirectToFavoritedDataRoleProviderState>(newState: Pick<RedirectToFavoritedDataRoleProviderState, K>): void {
    if (!this.unmounted) {
      this.setState(newState);
    }
  }
}
